import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";

import Button from "../../components/button";
import ICInput from "../../components/form/input";
import { Switch } from '@material-ui/core';

const AppSettingsForm = props => {
  const formik = useFormik({
    initialValues: {
      iosVersion: "",
      androidVersion: "",
      isIOSRedirect: false,
      iOSRedirectTo: "",
      iOSMessage: "",
      isAndroidRedirect: false,
      androidRedirectTo: "",
      androidMessage: "",
      maxNoOfPatientsInQueue: 0
    },
    validationSchema: Yup.object({
      androidVersion: Yup.number().required("Please enter a valid version"),
      iosVersion: Yup.number().required("Please enter a valid version"),
      isIOSRedirect: Yup.boolean(),
      iOSRedirectTo: Yup.string().optional().url("Please enter a valid URL"),
      iOSMessage: Yup.string().optional(),
      isAndroidRedirect: Yup.boolean(),
      androidRedirectTo: Yup.string().optional().url("Please enter a valid URL"),
      androidMessage: Yup.string().optional(),
      maxNoOfPatientsInQueue: Yup.number()
    }),
    onSubmit: values => {
      console.log("submit", values);
      props.onFormSubmit(values);
    }
  });

  useEffect(() => {
    if (props.data) {
      formik.setFieldValue("androidVersion", props.data.androidVersion);
      formik.setFieldValue("iosVersion", props.data.iosVersion);

      formik.setFieldValue("isIOSRedirect", props.data.isIOSRedirect.isRedirect);
      formik.setFieldValue("iOSRedirectTo", props.data.isIOSRedirect.redirectTo);
      formik.setFieldValue("iOSMessage", props.data.isIOSRedirect.message);

      formik.setFieldValue("isAndroidRedirect", props.data.isAndroidRedirect.isRedirect);
      formik.setFieldValue("androidRedirectTo", props.data.isAndroidRedirect.redirectTo);
      formik.setFieldValue("androidMessage", props.data.isAndroidRedirect.message);

      formik.setFieldValue("maxNoOfPatientsInQueue", props.data.maxNoOfPatientsInQueue);
    }
  }, [props.data]);

  return (
    <form className="w-100" onSubmit={formik.handleSubmit}>
      <div className="row">
        <div className="col-md-6">
          <div className="card custom-card-outlined">
            <h5 className="card-header">iOS</h5>
            <div className="card-body">
              <div>
                <div className="row">
                  <p className="col-md-6 font-weight-bold">iOS Version</p>
                  <ICInput
                    id="iosVersion"
                    name="iosVersion"
                    type="text"
                    className="col-md-5"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.iosVersion}
                    error={formik.touched.iosVersion && formik.errors.iosVersion ? true : false}
                    helperText={
                      formik.touched.iosVersion && formik.errors.iosVersion ? formik.errors.iosVersion : ""
                    }
                  />
                </div>

                <div className="row">
                  <p className="col-md-6 font-weight-bold">Redirect</p>
                  <Switch
                    className="custom-switch"
                    id="isIOSRedirect"
                    name="isIOSRedirect"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.isIOSRedirect}
                    value={formik.values.isIOSRedirect}
                  />
                </div>

                <div className="row">
                  <p className="col-md-6 font-weight-bold">Redirect Link</p>
                  <ICInput
                    id="iOSRedirectTo"
                    name="iOSRedirectTo"
                    type="text"
                    className="col-md-5"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.iOSRedirectTo}
                    error={formik.touched.iOSRedirectTo && formik.errors.iOSRedirectTo ? true : false}
                    helperText={
                      formik.touched.iOSRedirectTo && formik.errors.iOSRedirectTo ? formik.errors.iOSRedirectTo : ""
                    }
                  />
                </div>
                <div className="row">
                  <p className="col-md-6 font-weight-bold">Message</p>
                  <ICInput
                    id="iOSMessage"
                    name="iOSMessage"
                    type="text"
                    className="col-md-5"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.iOSMessage}
                    error={formik.touched.iOSMessage && formik.errors.iOSMessage ? true : false}
                    helperText={
                      formik.touched.iOSMessage && formik.errors.iOSMessage ? formik.errors.iOSMessage : ""
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card custom-card-outlined">
            <h5 className="card-header">Android</h5>
            <div className="card-body">
              <div className="row">
                <p className="col-md-6 font-weight-bold">Android Version</p>
                <ICInput
                  className="col-md-5"
                  id="androidVersion"
                  name="androidVersion"
                  type="text"
                  label=""
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.androidVersion}
                  error={formik.touched.androidVersion && formik.errors.androidVersion ? true : false}
                  helperText={
                    formik.touched.androidVersion && formik.errors.androidVersion ? formik.errors.androidVersion : ""
                  }
                />
              </div>

              <div className="row">
                <p className="col-md-6 font-weight-bold">Redirect</p>
                <Switch
                  id="isAndroidRedirect"
                  name="isAndroidRedirect"
                  type="checkbox"
                  className="custom-switch"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.isAndroidRedirect}
                  checked={formik.values.isAndroidRedirect}
                />
              </div>
              <div className="row">
                <p className="col-md-6 font-weight-bold">Redirect Link</p>
                <ICInput
                  id="androidRedirectTo"
                  name="androidRedirectTo"
                  type="text"
                  className="col-md-5"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.androidRedirectTo}
                  error={formik.touched.androidRedirectTo && formik.errors.androidRedirectTo ? true : false}
                  helperText={
                    formik.touched.androidRedirectTo && formik.errors.androidRedirectTo ? formik.errors.androidRedirectTo : ""
                  }
                />
              </div>
              <div className="row">
                <p className="col-md-6 font-weight-bold">Message</p>
                <ICInput
                  id="androidMessage"
                  name="androidMessage"
                  type="text"
                  className="col-md-5"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.androidMessage}
                  error={formik.touched.androidMessage && formik.errors.androidMessage ? true : false}
                  helperText={
                    formik.touched.androidMessage && formik.errors.androidMessage ? formik.errors.androidMessage : ""
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <br/>

      <div className="row">
        <div className="col-md-6">
          <div className="card custom-card-outlined">
            <h5 className="card-header">Patient Queue</h5>
            <div className="card-body">
              <div className="row">
                <p className="col-md-6 font-weight-bold">Queue Cap</p>
                <ICInput
                  id="maxNoOfPatientsInQueue"
                  name="maxNoOfPatientsInQueue"
                  type="number"
                  className="col-md-5"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.maxNoOfPatientsInQueue}
                  error={formik.touched.maxNoOfPatientsInQueue && formik.errors.maxNoOfPatientsInQueue ? true : false}
                  helperText={
                    formik.touched.maxNoOfPatientsInQueue && formik.errors.maxNoOfPatientsInQueue ? formik.errors.androidMessage : ""
                  }
                />
              </div>
            </div>
          </div>
        </div>

        {/*<div className="col-md-6"></div>*/}
      </div>

      <br />
      <Button className="mt-2" title="Update App Settings" type="submit" />
    </form>
  );
};

export default AppSettingsForm;

AppSettingsForm.defaultProps = {
  serverErrorMsg: "",
  successMsg: ""
};

AppSettingsForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string,
  successMsg: PropTypes.string
};
